import { useEffect, useMemo, useRef } from 'react';
import { selectedItem } from './definitions';

/**
 * The menu item the current route belongs to: what the rail highlights and what the top
 * bar's breadcrumbs name. Both ask this one hook, so they cannot disagree.
 *
 * It remembers the last item it found, so a plugin's sub-page keeps the item the admin opened
 * it from (Scan Targets, not Scanners). Only a hit is remembered: a screen that matches
 * nothing should not make the next one forget. See `pluginItemFor`.
 */
export const useSelectedItem = (menu, route) => {
  const lastSelected = useRef(null);
  // `lastSelected` is deliberately not a dependency: it is read when the route changes.
  const selected = useMemo(() => selectedItem(menu, route, lastSelected.current), [menu, route]);
  useEffect(() => {
    if (selected) lastSelected.current = selected;
  }, [selected]);
  return selected;
};

export default useSelectedItem;
